// extracted by mini-css-extract-plugin
export default {"container":"tax_3lzAu","filters":"tax_fil_pF849"};